// extracted by mini-css-extract-plugin
module.exports = {"autosuggest-container":"SupplierAutosuggest_autosuggest-container__2GzXQ"};